import { MenuItem } from '@bn/layout';

import { AppRoutes } from '../../core/enums';

export const mainMenuConfig: () => MenuItem[] = () => [
  { name: 'Customers', icon: ['fad', 'user-group'], route: AppRoutes.Overview, isIndependentRootItem: true },
  { name: 'Pricing', icon: ['fad', 'circle-dollar'], route: AppRoutes.Pricing, isIndependentRootItem: true },
  { name: 'Contract', icon: ['fad', 'file-lines'], route: AppRoutes.Contract, isIndependentRootItem: true },
];

export const mainMenuChildRoutes: () => Record<string, string> = () => ({});
